new gridjs.Grid({
  columns: [
    "Nr decyzji",
    "Data",
    "Nr działki",
    "Miejscowość",
    "Adres",
    "Rodzaj",
    "Status",
    "Uwagi"
  ],
  server: {
    url: 'https://wz.dopiewo.pl/wz.json',
    then: data => data.map(item => [item.nrdecyzji, item.data, item.nrdzialki, item.miejscowosc, item.adres, item.rodzaj, item.status, item.uwagi])
  },
  search: {
    enabled: true
  },
  sort: true,
  pagination: {
    enabled: true,
    limit: 50,
    summary: true
  },
  language: {
    'search': {
      'placeholder': '🔍 Wpisz słowo kluczowe...'
    },
    'loading': 'Trwa ładowanie danych',
    'pagination': {
      'previous': '⬅️',
      'next': '➡️',
      'showing': 'Widoczne rekordy od',
      'results': () => 'wszystkich rekordów',
      'of': 'z',
      'to': 'do'
    },
    noRecordsFound: 'Nie znaleziono wyników',
    error: 'Wystąpił błąd w trakcie pobierania danych'
  }
}).render(document.getElementById("wrapper"));

